import { PiArrowRight } from 'react-icons/pi'
import { Link } from 'react-router-dom'

import MotionDiv from '@/components/common/Motion/MotionDiv'
import MotionText from '@/components/common/Motion/MotionText'

interface RelatedArticle {
  slug: string
  title: string
}

interface RelatedArticlesProps {
  articles: RelatedArticle[]
}

const RelatedArticles = ({ articles }: RelatedArticlesProps) => {
  if (articles.length === 0) return null

  return (
    <MotionDiv className="pt-6 border-t border-zinc-200">
      <MotionText as="h3" className="text-base-black text-base font-semibold mb-4">
        Susiję straipsniai
      </MotionText>
      <div className="space-y-2">
        {articles.map((article) => (
          <Link
            key={article.slug}
            to={`/blog/${article.slug}`}
            className="flex items-center justify-between p-3 bg-zinc-50 rounded-lg hover:bg-zinc-100 transition-colors"
          >
            <MotionText as="span" className="text-zinc-700 text-sm font-medium">
              {article.title}
            </MotionText>
            <PiArrowRight className="w-4 h-4 text-zinc-500" />
          </Link>
        ))}
      </div>
    </MotionDiv>
  )
}

export default RelatedArticles
